<ng-container [ngSwitch]="step">
  <db-create-website-install
    *ngSwitchCase="'websiteInstallation'"
    (resized)="resize($event)"
    (createSubmitted)="createWebsite($event)"
    (cloneSubmitted)="cloneWebsite($event)"
    [userSubscription]="userSubscription">

  </db-create-website-install>

  <db-website-install-loading-dialog
    *ngSwitchCase="'creationProcess'"
    [step3]="creationProcessStep"
    [insidePageContent]="false"></db-website-install-loading-dialog>

  <db-clone-progress
    *ngSwitchCase="'cloneProcess'"
    [websiteUrl]="cloneWebsiteUrl"
    [dataCenter]="dataCenter"
    (failed)="showManualMigrationModal()"></db-clone-progress>
</ng-container>
